<template>
  <section class="excess-form">
    <section class="flex-sb-center">
      <section
        v-if="isAdjust"
        class="form-half">
        <div class="tr">
          <p class="fw-600 fs-16 mg-b-16 color-dark">Old Excess</p>
        </div>
        <div
          v-if="form.company_id!=17"
          class="form-item">
          <span>Section I - Material Damage</span>
          <div class="flex-excess">
            <v-input
              v-model="oldForm.mat_dam_ex"
              :keyFloatNumber="true"
              maxlength="8"
              disabled
              prepend="$" />
            <v-checkbox
              v-model="oldExcessCheckbox['mat_dam_ex'].status"
              disabled>or</v-checkbox>
            <v-input
              v-model="oldForm.mat_dam_ex_vl"
              :keyFloatNumber="true"
              maxlength="8"
              disabled
              append="%" />
            <span>of</span>
            <v-select
              v-model="oldForm.mat_dam_ex_typ"
              disabled
              :list="decorationOptions"  />
          </div>
        </div>
        <template     v-else>
          <div class="form-item">
            <span>Section I - Material Damage</span>
          </div>
          <div class="form-item">
            <span>Water Damage</span>
            <div class="flex-excess">
              <v-input
                v-model="oldForm.mat_water_dam_ex"
                :keyFloatNumber="true"
                maxlength="8"
                disabled
                prepend="$" />
              <v-checkbox
                v-model="oldExcessCheckbox['mat_water_dam_ex'].status"
                disabled>or</v-checkbox>
              <v-input
                v-model="oldForm.mat_water_dam_ex_vl"
                :keyFloatNumber="true"
                maxlength="8"
                disabled
                append="%" />
              <span>of</span>
              <v-select
                v-model="oldForm.mat_water_dam_ex_typ"
                disabled
                :list="decorationOptions"  />
            </div>
          </div>
          <div class="form-item">
            <span>Others</span>
            <div class="flex-excess">
              <v-input
                v-model="oldForm.mat_other_dam_ex"
                :keyFloatNumber="true"
                maxlength="8"
                disabled
                prepend="$" />
              <v-checkbox
                v-model="oldExcessCheckbox['mat_other_dam_ex'].status"
                disabled>or</v-checkbox>
              <v-input
                v-model="oldForm.mat_other_dam_ex_vl"
                :keyFloatNumber="true"
                maxlength="8"
                disabled
                append="%" />
              <span>of</span>
              <v-select
                v-model="oldForm.mat_other_dam_ex_typ"
                disabled
                :list="decorationOptions"  />
            </div>
          </div>
        </template>
        <div class="form-item">
          <span>Section II - 3rd Party Liability - Damage to Principal’s Property</span>
          <div class="flex-excess">
            <v-input
              v-model="oldForm.principal_prop_ex"
              disabled
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
            <v-checkbox
              v-model="oldExcessCheckbox['principal_prop_ex'].status"
              :disabled="disabled">or</v-checkbox>
            <v-input
              v-model="oldForm.principal_prop_ex_vl"
              :keyFloatNumber="true"
              maxlength="8"
              disabled
              append="%" />
            <span>of</span>
            <v-select
              v-model="oldForm.principal_prop_ex_typ"
              disabled
              :list="decorationOptions"  />
          </div>
        </div>
        <div class="form-item">
          <span>Section II - 3rd Party Liability - Damage due to Water or Vibration</span>
          <div class="flex-excess">
            <v-input
              v-model="oldForm.water_dmge_ex"
              disabled
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
            <v-checkbox
              v-model="oldExcessCheckbox['water_dmge_ex'].status"
              :disabled="disabled">or</v-checkbox>
            <v-input
              v-model="oldForm.water_dmge_ex_vl"
              :keyFloatNumber="true"
              maxlength="8"
              disabled
              append="%" />
            <span>of</span>
            <v-select
              v-model="oldForm.water_dmge_ex_typ"
              disabled
              :list="decorationOptions"  />
          </div>
        </div>
        <div class="form-item">
          <span>Section II - Vibration</span>
          <div class="flex-excess">
            <v-input
              v-model="oldForm.vibration_ex"
              disabled
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
            <v-checkbox
              v-model="oldExcessCheckbox['vibration_ex'].status"
              :disabled="disabled">or</v-checkbox>
            <v-input
              v-model="oldForm.vibration_ex_vl"
              :keyFloatNumber="true"
              maxlength="8"
              disabled
              append="%" />
            <span>of</span>
            <v-select
              v-model="oldForm.vibration_ex_typ"
              disabled
              :list="decorationOptions"  />
          </div>
        </div>
        <div class="form-item">
          <span>Section II - Others</span>
          <div class="flex-excess">
            <v-input
              v-model="formData.other_loss_ex"
              disabled
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
            <v-checkbox
              v-model="oldExcessCheckbox['other_loss_ex'].status"
              :disabled="disabled">or</v-checkbox>
            <v-input
              v-model="oldForm.other_loss_ex_vl"
              :keyFloatNumber="true"
              maxlength="8"
              disabled
              append="%" />
            <span>of</span>
            <v-select
              v-model="oldForm.other_loss_ex_typ"
              disabled
              :list="decorationOptions"  />
          </div>
        </div>
      </section>
      <section :class="{'form-half':isAdjust}">
        <div class="tr">
          <p class="fw-600 fs-16 mg-b-16 color-dark">New Excess</p>
        </div>
        <div
          v-if="form.company_id!=17"
          class="form-item">
          <span>Section I - Material Damage</span>
          <div class="flex-excess">
            <v-input
              v-model="formData.mat_dam_ex"
              :keyFloatNumber="true"
              maxlength="8"
              :disabled="disabled"
              prepend="$" />
            <v-checkbox
              v-model="excessCheckbox['mat_dam_ex'].status"
              :disabled="disabled">or</v-checkbox>
            <v-input
              v-model="formData.mat_dam_ex_vl"
              :keyFloatNumber="true"
              maxlength="8"
              :disabled="!excessCheckbox['mat_dam_ex'].status||disabled"
              append="%" />
            <span>of</span>
            <v-select
              v-model="formData.mat_dam_ex_typ"
              :disabled="!excessCheckbox['mat_dam_ex'].status||disabled"
              :list="decorationOptions"  />
          </div>
        </div>
        <template     v-else>
          <div class="form-item">
            <span>Section I - Material Damage</span>
          </div>
          <div class="form-item">
            <span>Water Damage</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.mat_water_dam_ex"
                :keyFloatNumber="true"
                maxlength="8"
                :disabled="disabled"
                prepend="$" />
              <v-checkbox
                v-model="excessCheckbox['mat_water_dam_ex'].status"
                :disabled="disabled">or</v-checkbox>
              <v-input
                v-model="formData.mat_water_dam_ex_vl"
                :keyFloatNumber="true"
                maxlength="8"
                :disabled="!excessCheckbox['mat_water_dam_ex'].status||disabled"
                append="%" />
              <span>of</span>
              <v-select
                v-model="formData.mat_water_dam_ex_typ"
                :disabled="!excessCheckbox['mat_water_dam_ex'].status||disabled"
                :list="decorationOptions"  />
            </div>
          </div>
          <div class="form-item">
            <span>Others</span>
            <div class="flex-excess">
              <v-input
                v-model="formData.mat_other_dam_ex"
                :keyFloatNumber="true"
                maxlength="8"
                :disabled="disabled"
                prepend="$" />
              <v-checkbox
                v-model="excessCheckbox['mat_other_dam_ex'].status"
                :disabled="disabled">or</v-checkbox>
              <v-input
                v-model="formData.mat_other_dam_ex_vl"
                :keyFloatNumber="true"
                maxlength="8"
                :disabled="!excessCheckbox['mat_other_dam_ex'].status||disabled"
                append="%" />
              <span>of</span>
              <v-select
                v-model="formData.mat_other_dam_ex_typ"
                :disabled="!excessCheckbox['mat_other_dam_ex'].status||disabled"
                :list="decorationOptions"  />
            </div>
          </div>
        </template>
        <div class="form-item">
          <span>Section II - 3rd Party Liability - Damage to Principal’s Property</span>
          <div class="flex-excess">
            <v-input
              v-model="formData.principal_prop_ex"
              :disabled="disabled"
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
            <v-checkbox
              v-model="excessCheckbox['principal_prop_ex'].status"
              :disabled="disabled">or</v-checkbox>
            <v-input
              v-model="formData.principal_prop_ex_vl"
              :keyFloatNumber="true"
              maxlength="8"
              :disabled="!excessCheckbox['principal_prop_ex'].status||disabled"
              append="%" />
            <span>of</span>
            <v-select
              v-model="formData.principal_prop_ex_typ"
              :disabled="!excessCheckbox['principal_prop_ex'].status||disabled"
              :list="decorationOptions"  />
          </div>
        </div>
        <div class="form-item">
          <span>Section II - 3rd Party Liability - Damage due to Water or Vibration</span>
          <div class="flex-excess">
            <v-input
              v-model="formData.water_dmge_ex"
              :disabled="disabled"
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
            <v-checkbox
              v-model="excessCheckbox['water_dmge_ex'].status"
              :disabled="disabled">or</v-checkbox>
            <v-input
              v-model="formData.water_dmge_ex_vl"
              :keyFloatNumber="true"
              maxlength="8"
              :disabled="!excessCheckbox['water_dmge_ex'].status||disabled"
              append="%" />
            <span>of</span>
            <v-select
              v-model="formData.water_dmge_ex_typ"
              :disabled="!excessCheckbox['water_dmge_ex'].status||disabled"
              :list="decorationOptions"  />
          </div>
        </div>
        <div class="form-item">
          <span>Section II - Vibration</span>
          <div class="flex-excess">
            <v-input
              v-model="formData.vibration_ex"
              :disabled="disabled"
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
            <v-checkbox
              v-model="excessCheckbox['vibration_ex'].status"
              :disabled="disabled">or</v-checkbox>
            <v-input
              v-model="formData.vibration_ex_vl"
              :keyFloatNumber="true"
              maxlength="8"
              :disabled="!excessCheckbox['vibration_ex'].status||disabled"
              append="%" />
            <span>of</span>
            <v-select
              v-model="formData.vibration_ex_typ"
              :disabled="!excessCheckbox['vibration_ex'].status||disabled"
              :list="decorationOptions"  />
          </div>
        </div>
        <div class="form-item">
          <span>Section II - Others</span>
          <div class="flex-excess">
            <v-input
              v-model="formData.other_loss_ex"
              :disabled="disabled"
              :keyFloatNumber="true"
              maxlength="8"
              prepend="$" />
            <v-checkbox
              v-model="excessCheckbox['other_loss_ex'].status"
              :disabled="disabled">or</v-checkbox>
            <v-input
              v-model="formData.other_loss_ex_vl"
              :keyFloatNumber="true"
              maxlength="8"
              :disabled="!excessCheckbox['other_loss_ex'].status||disabled"
              append="%" />
            <span>of</span>
            <v-select
              v-model="formData.other_loss_ex_typ"
              :disabled="!excessCheckbox['other_loss_ex'].status||disabled"
              :list="decorationOptions"  />
          </div>
        </div>
      </section>
    </section>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'

export default {
  name: 'DecorationExcessForm',
  mixins: [MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    disabled:{
      type:Boolean,
      default:false
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isAdjust:{
      type:Boolean,
      default:false
    },
  },
  data() {
    return {
      oldFormDataLock: -1,
      formData: {
        mat_dam_ex: '',
        mat_dam_ex_vl: '',
        mat_dam_ex_typ: '',
        principal_prop_ex: '',
        principal_prop_ex_vl: '',
        principal_prop_ex_typ: '',
        water_dmge_ex: '',
        water_dmge_ex_vl: '',
        water_dmge_ex_typ: '',
        vibration_ex: '',
        vibration_ex_vl: '',
        vibration_ex_typ: '',
        other_loss_ex: '',
        other_loss_ex_vl: '',
        other_loss_ex_typ: '',
        mat_water_dam_ex: '',
        mat_water_dam_ex_typ: '',
        mat_water_dam_ex_vl: '',
        mat_other_dam_ex: '',
        mat_other_dam_ex_typ: '',
        mat_other_dam_ex_vl: '',
      },
      excessCheckbox: {
        'mat_water_dam_ex': {
          status: false,
          vlKey: 'mat_water_dam_ex_vl',
          typKey: 'mat_water_dam_ex_typ'
        },
        'mat_other_dam_ex': {
          status: false,
          vlKey: 'mat_other_dam_ex_vl',
          typKey: 'mat_other_dam_ex_typ'
        },
        'mat_dam_ex': {
          status: false,
          vlKey: 'mat_dam_ex_vl',
          typKey: 'mat_dam_ex_typ'
        },
        'principal_prop_ex': {
          status: false,
          vlKey: 'principal_prop_ex_vl',
          typKey: 'principal_prop_ex_typ'
        },
        'water_dmge_ex': {
          status: false,
          vlKey: 'water_dmge_ex_vl',
          typKey: 'water_dmge_ex_typ'
        },
        'vibration_ex': {
          status: false,
          vlKey: 'vibration_ex_vl',
          typKey: 'vibration_ex_typ'
        },
        'other_loss_ex': {
          status: false,
          vlKey: 'other_loss_ex_vl',
          typKey: 'other_loss_ex_typ'
        },
      },
      oldExcessCheckbox: {
        'mat_dam_ex': {
          status: false,
          vlKey: 'mat_dam_ex_vl',
          typKey: 'mat_dam_ex_typ'
        },
        'principal_prop_ex': {
          status: false,
          vlKey: 'principal_prop_ex_vl',
          typKey: 'principal_prop_ex_typ'
        },
        'water_dmge_ex': {
          status: false,
          vlKey: 'water_dmge_ex_vl',
          typKey: 'water_dmge_ex_typ'
        },
        'vibration_ex': {
          status: false,
          vlKey: 'vibration_ex_vl',
          typKey: 'vibration_ex_typ'
        },
        'other_loss_ex': {
          status: false,
          vlKey: 'other_loss_ex_vl',
          typKey: 'other_loss_ex_typ'
        },
      },
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.formDataLock !== this.oldFormDataLock) {
          this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
            }
          })
          // 初始化
          Object.keys(this.excessCheckbox).some(key => {
            const { status, vlKey, typKey } = this.excessCheckbox[key]
            if(val[vlKey]) {
              this.excessCheckbox[key].status = true
            }
            if(this.oldForm[vlKey]){
              this.oldExcessCheckbox[key].status = true
            }
          })
        }
      }
    }
  },
  methods: {
    submitForm() {
      // 整合數據
      let params = JSON.parse(JSON.stringify(this.formData))
      Object.keys(this.excessCheckbox).some(key => {
        const { status, vlKey, typKey } = this.excessCheckbox[key]
        if(!status) {
          // delete params[vlKey]
          // delete params[typKey]
          // 傳空值出去，覆蓋父組件的數據
          params[vlKey] = ''
          params[typKey] = ''
        }
      })
      // 後續傳出去
      this.$emit('getFormData', params)
      return params
    }
  }
}
</script>

<style lang="scss" scoped>
.excess-form {
    .flex-excess {
            display: flex;
            align-items: center;
            & > .el-checkbox {
                margin: 0 15px;
            }
            & > span {
                display: inline-block;
                padding: 0 15px;
            }
        }
        .form-excess-half {
            width: 500px;
        }
}
</style>
